export default {"src":"/_next/static/media/loreal_black.467de67e.svg","height":145,"width":800,"blurWidth":0,"blurHeight":0};